import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { GoldPageRoutingModule } from './gold-routing.module';

import { MatSelectModule } from '@angular/material/select';

import { GoldPage } from './gold.page';
import { UpgradeFormModule } from '../upgrade-form/upgrade-form.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatSelectModule,
    GoldPageRoutingModule,
    UpgradeFormModule
  ],
  declarations: [GoldPage]
})
export class GoldPageModule {}
